import { Link } from 'react-router-dom'

import type { Person } from '@/demo/data'

export interface PersonChipProps {
  person: Person
  /** Optional trailing figure (e.g. an allocation percentage) shown inside the chip. */
  allocation?: string
}

/**
 * A person as a linked chip — initial avatar, name, optional allocation figure.
 * The wrapper is a `<Link>`, never a button, so Cmd+click opens the person's
 * page in a new tab.
 */
export function PersonChip({ person, allocation }: PersonChipProps) {
  return (
    <Link
      to={`/resources/people/${person.id}`}
      className="inline-flex items-center gap-1.5 rounded-full border border-border px-2 py-0.5 text-xs text-ink-soft hover:bg-muted"
    >
      <span
        aria-hidden
        className="flex h-4 w-4 items-center justify-center rounded-full bg-people-bg text-[0.5625rem] font-semibold text-people-ink"
      >
        {person.initial}
      </span>
      {person.name}
      {allocation && <span className="v-figure tabular-nums text-muted-foreground">{allocation}</span>}
    </Link>
  )
}
